//libs
import React, { memo } from 'react';

//styles
import { Title, Container, UpArrow, RightArrow, Count, Wrapper } from './styles';

import DownArrow from '@nykaa/ui-components/Icons/chevron-down-small';

//defs
interface ICollapsedFilter {
  title: string;
  isCollapsedView: boolean;
  onArrowClick: () => void;
  selectedFiltersCount?: number;
  isOverlayFilter?: boolean;
}

const ARROW_SIZE = '20px';

function CollapsedFilter({
  title,
  isCollapsedView,
  onArrowClick,
  selectedFiltersCount = 0,
  isOverlayFilter,
}: ICollapsedFilter) {
  return (
    <Container onClick={onArrowClick}>
      <Title isCollapsedView={isCollapsedView}>{title}</Title>
      <Wrapper>
        {selectedFiltersCount > 0 && <Count>{selectedFiltersCount}</Count>}
        {isCollapsedView ? (
          <DownArrow size={ARROW_SIZE} />
        ) : isOverlayFilter ? (
          <RightArrow size={ARROW_SIZE} />
        ) : (
          <UpArrow size={ARROW_SIZE} />
        )}
      </Wrapper>
    </Container>
  );
}

export default memo(CollapsedFilter);
